document.addEventListener('DOMContentLoaded', function () {
  const productInfo = document.querySelector('product-info');
  const productForm = document.querySelector('.product-form');
  const quantityInput = productForm.querySelector('input[name="quantity"]');
  const variantIdInput = productForm.querySelector('input[name="id"]');

  const buttonPrice = productForm.querySelector('.js-button-product-price');

  const simpleProductPrice = parseInt(productInfo.dataset.simpleProductPrice, 10) / 100 || 0;
  const priceByVariant = JSON.parse(productInfo.dataset.priceByVariant || '{}');
  const qtyHeading = productInfo.dataset.qtyHeading || null;
  const subscriptionsHeading = productInfo.dataset.subscriptionsHeading || null;

  const singularName = productInfo.dataset.singularName ? extractText(productInfo.dataset.singularName) : 'item';
  const pluralName = productInfo.dataset.pluralName ? extractText(productInfo.dataset.pluralName) : 'items';

  let rechargeWidgetSettings = null;
  let rechargeProductData = null;
  let rechargeWidgetTarget = null;

  let productPrice = simpleProductPrice;
  let productQuantity = 1;
  let subscriptionDiscount = 0;
  let quantityDiscount = 0;

  let subOriginalPriceItem = null;
  let subDiscountPriceItem = null;
  let oneOriginalPriceItem = null;
  let oneDiscountPriceItem = null;

  let maxSubDiscount = 0;

  function renderQuantitySelector() {
    const newContainer = document.getElementById('new-quantity-selector-container');

    if (!window.discountRules || !window.discountRules.length || !newContainer) {
      return;
    }

    const radioName = 'discount-quantity';
    const containerClass = 'discount-quantity';
    const labelClass = 'discount-quantity__label';
    const inputClass = 'discount-quantity__input';
    const textClass = 'discount-quantity__text';
    const discountClass = 'discount-quantity__discount';

    const container = document.createElement('div');
    container.classList.add(containerClass);

    window.discountRules.forEach((rate, index) => {
      const inputId = `discount-quantity-${index}`;

      const label = document.createElement('label');
      label.classList.add(labelClass);
      label.htmlFor = inputId;

      const input = document.createElement('input');
      input.classList.add(inputClass);
      input.type = 'radio';
      input.name = radioName;
      input.value = rate.min;
      input.checked = index === 0;
      input.id = inputId;
      input.classList.add('hidden');

      const text = document.createElement('span');
      text.classList.add(textClass);
      text.innerText = `${rate.min} ${pluralize(rate.min, singularName, pluralName)}`;

      const discount = document.createElement('span');
      discount.classList.add(discountClass);
      discount.innerText = `Save ${rate.discount * 100}%`;
      if (rate.discount === 0) {
        discount.classList.add('hidden');
      }

      label.appendChild(input);
      label.appendChild(text);
      label.appendChild(discount);

      container.appendChild(label);

      input.addEventListener('change', () => {
        const quantity = parseInt(input.value, 10);
        quantityInput.value = quantity;
        quantityDiscount = rate.discount;
        productQuantity = quantity;
        updatePrice();
      });
    });

    if (!qtyHeading) {
      container.classList.add('no-heading');
    } else {
      container.dataset.heading = qtyHeading;
    }

    // const prevQuantity = document.querySelector('#mr-div-embedded-prp-vd-page');
    // prevQuantity.parentNode.insertBefore(container, prevQuantity);
    newContainer.appendChild(container);
  }

  function updatePrice() {
    const totalDiscountMultiplier = getTotalDiscountMultiplier();
    const price = productPrice * totalDiscountMultiplier * productQuantity;
    const formattedPrice = formatMoney(price);

    buttonPrice.innerText = formattedPrice;

    const originalPrice = productPrice * productQuantity;
    const formattedOriginalPrice = formatMoney(originalPrice);

    if (subOriginalPriceItem) {
      subOriginalPriceItem.innerText = formattedOriginalPrice;
    }

    if (subDiscountPriceItem) {
      const subTotalDiscountMultiplier = getTotalDiscountMultiplier(maxSubDiscount);
      const subDiscountPrice = productPrice * productQuantity * subTotalDiscountMultiplier;
      const subFormattedDiscountPrice = formatMoney(subDiscountPrice);

      subDiscountPriceItem.innerText = subFormattedDiscountPrice;
    }

    if (oneOriginalPriceItem) {
      oneOriginalPriceItem.innerText = formattedOriginalPrice;
    }

    if (oneDiscountPriceItem) {
      const oneDiscountPrice = productPrice * productQuantity * (1 - quantityDiscount);
      const formattedOneDiscountPrice = formatMoney(oneDiscountPrice);
      oneDiscountPriceItem.innerText = formattedOneDiscountPrice;

      if (oneOriginalPriceItem) {
        oneOriginalPriceItem.classList.toggle('hidden', oneDiscountPrice === originalPrice);
      }
    }
  }

  function setVariationPrice(variationId) {
    const price = parseInt(priceByVariant.find((item) => item.id == variationId)?.price, 10) / 100 || 0;

    if (price) {
      productPrice = price;
    } else {
      productPrice = simpleProductPrice;
    }
  }

  function getTotalDiscountMultiplier(subDiscount = subscriptionDiscount, qtyDiscount = quantityDiscount) {
    return 1 - subDiscount - qtyDiscount + subDiscount * qtyDiscount;
  }

  function extractText(input) {
    return input.replace(/^[0-9]+\s*/, '');
  }

  if (variantIdInput) {
    variantIdInput.addEventListener('change', () => {
      const variantId = variantIdInput.value;

      setTimeout(() => {
        setVariationPrice(variantId);
        updatePrice();
      }, 0);
    });
  }

  function preprocessRechargeWidget() {
    if (!rechargeWidgetSettings) {
      console.error('Recharge Widget Settings is missing!');
      return;
    }

    if (!rechargeProductData) {
      console.error('Recharge Product Data is missing');
      return;
    }

    if (!rechargeWidgetTarget) {
      console.error('Recharge widget target is missing');
      return;
    }

    let discountValue = 0;

    try {
      discountValue = rechargeProductData.selling_plan_groups[0].selling_plans[0].price_adjustments_value;
    } catch (e) {
      console.error(e);
    }

    const rechargeItemTopHtml = `<div class="rc_widget__option__selector" data-selector-subsave="">
        <label
            class="rc-radio__label rc_widget__option__label"
            data-label-subsave=""
        >
          <span class="rc-option__text" data-label-text-subsave="">
            ${rechargeWidgetSettings.subscribe_message}
          </span>
          <span class="rc-option__discount rc_widget__option__discount" data-label-discount="">
                ${discountValue}%
          </span>
          <span
              class="rc-option__price rc_widget__price rc_widget__price--subsave"
              aria-label="recurring price"
              data-price-subsave=""
              >
              $0
          </span>
        </label>
    </div>
    `;

    // rechargeWidgetTarget.insertAdjacentHTML('afterbegin', rechargeItemTopHtml);
    const rcRadioElement = rechargeWidgetTarget.querySelector('.rc-radio.rc-option__subsave');

    if (rcRadioElement && !rcRadioElement.querySelector('.rc_widget__option__selector')) {
      rcRadioElement.insertAdjacentHTML('afterbegin', rechargeItemTopHtml);
    }

    processRechargeWidget();
  }

  function processRechargeWidget() {
    target = rechargeWidgetTarget;
    const subsaveOption = target.querySelector('.rc-option[data-option-subsave]');
    const onetimeOption = target.querySelector('.rc-option[data-option-onetime]');

    const subsaveDiscountText = subsaveOption.querySelector('.rc-option__discount');
    const subsaveDiscount = getFirstIntegerFromString(subsaveDiscountText.innerText);

    if (!subsaveDiscount) {
      return;
    }

    const subsaveDiscountFloat = subsaveDiscount / 100;

    maxSubDiscount = subsaveDiscountFloat;

    const options = [subsaveOption];

    subsaveOption.addEventListener('click', () => updateSubscriptionDiscount(subsaveDiscountFloat));

    if (onetimeOption) {
      onetimeOption.addEventListener('click', () => updateSubscriptionDiscount(0));
      options.push(onetimeOption);
    }

    if (!onetimeOption && subsaveOption) {
      subsaveOption.classList.add('rc-option--active');
    }

    options.forEach((option) => {
      const priceItem = option.querySelector('.rc-option__price');
      const parentElement = priceItem.parentElement;

      const discountPriceItem = priceItem.cloneNode(true);

      priceItem.classList.add('_original-price');
      discountPriceItem.classList.add('_discount-price');

      parentElement.insertBefore(discountPriceItem, priceItem);

      if (option.classList.contains('rc_widget__option--subsave')) {
        subOriginalPriceItem = priceItem;
        subDiscountPriceItem = discountPriceItem;
      } else {
        oneOriginalPriceItem = priceItem;
        oneDiscountPriceItem = discountPriceItem;
      }
    });

    if (!subscriptionsHeading) {
      target.classList.add('no-heading');
    } else {
      target.dataset.heading = subscriptionsHeading;
    }

    setTimeout(() => {
      if (subsaveOption.classList.contains('rc-option--active') || !onetimeOption) {
        updateSubscriptionDiscount(subsaveDiscountFloat);
      }

      const subsaveOptionSelector = target.querySelector('.rc-selling-plans__dropdown');
      subsaveOptionSelector.addEventListener('change', () => updateSubscriptionDiscount(subsaveDiscountFloat, true));

      if (subsaveOption) {
        updateSubscriptionOptionTitle();
        moveSubscriptionDetails();
        wrapSubscriptionSelect();
        addRechargeSubscriptionBenefits();
      }
    }, 50);

    const updateSubscriptionDiscount = (discount, force = false) => {
      if (subscriptionDiscount === discount && !force) {
        return;
      }

      subscriptionDiscount = discount;
      updatePrice();
    };

    function addRechargeSubscriptionBenefits() {
      const subsaveDropdown = subsaveOption.querySelector('.rc-selling-plans__dropdown-wrapper');

      if (!subsaveDropdown) {
        return;
      }

      const benefits = productInfo.querySelectorAll('.product__recharge-benefit');

      if (!benefits || !benefits.length) {
        return;
      }

      const benefitsContainer = document.createElement('div');
      benefitsContainer.classList.add('product__recharge-benefits');

      benefits.forEach((benefit) => {
        benefit.classList.remove('hidden');
        benefitsContainer.appendChild(benefit);
      });

      subsaveDropdown.after(benefitsContainer);
    }

    function wrapSubscriptionSelect() {
      const select = subsaveOption.querySelector('.rc-selling-plans__dropdown');

      if (!select) {
        return;
      }

      const wrapper = document.createElement('div');
      wrapper.classList.add('rc-selling-plans__dropdown-wrapper');
      select.parentElement.insertBefore(wrapper, select);
      wrapper.appendChild(select);
    }

    function moveSubscriptionDetails() {
      const details = target.querySelector('.rc_popup');

      subsaveOption.querySelector('.rc-selling-plans')?.appendChild(details);
    }

    function updateSubscriptionOptionTitle() {
      const titleElement = subsaveOption.querySelector('.rc-option__text');
      titleElement.innerHTML = titleElement.innerHTML.replace(/\[([^\]]+)\]/, '<span class="discount-badge">$1</span>');
    }
  }

  //recharge
  waitForElement(
    async (parent, target) => {
      rechargeWidgetTarget = target;

      if ('ReChargeWidget' in window) {
        const [settings, productData] = await Promise.all([
          window.ReChargeWidget.api.fetchWidgetSettings(),
          window.ReChargeWidget.api.fetchProduct(window.product.productId),
        ]);

        rechargeWidgetSettings = settings;
        rechargeProductData = productData;
      }

      preprocessRechargeWidget();
    },
    '.product-form',
    '.rc-container'
  );

  //quantity selector
  waitForElement(
    (parent, target) => {
      const prepareDiscountRules = (discountRules) => {
        const prepareddiscountRules = [];

        for (let i = 0; i < discountRules.length; i++) {
          const min = discountRules[i].count;
          const max = i + 1 < discountRules.length ? discountRules[i + 1].count : Infinity;
          const discount = discountRules[i].discount / 100;

          prepareddiscountRules.push({ min, max, discount });
        }

        window.discountRules = prepareddiscountRules;
      };

      const discountRules = [];

      const buttons = target.querySelectorAll('.mr-quantity-option');
      buttons.forEach((button) => {
        const countText = button.querySelector('.mr-quantity-option_text');
        const discountText = button.querySelector('.mr-quantity-option_discount-text');

        if (!countText || !discountText) {
          return;
        }

        const count = getFirstIntegerFromString(countText.innerText);
        const discount = getFirstIntegerFromString(discountText.innerText);

        if (count !== null && discount !== null) {
          discountRules.push({ count, discount });
        }
      });

      prepareDiscountRules(discountRules);
      renderQuantitySelector();
    },
    '#mr-div-embedded-prp-vd-page',
    '.mr-embedded-widget__quantity-option-con'
  );
});

(function () {
  if (window.StampedIOSettings.hideIfEmpty) {
    document.addEventListener(`product-rating-loaded:${window.product.productId}`, function (event) {
      const reviewsCount = event.detail.count;

      if (reviewsCount === 0) {
        setTimeout(() => {
          const stampedMainWidget = document.getElementById('stamped-main-widget');
          stampedMainWidget.style.display = 'none';
        }, 0);
      }
    });
  }
})();
